import React from "react";
import { Container } from "./styles";

/**
 * compact, read-only row identifying a track (thumbnail, title | variation, album)
 * - for modals acting on a single track, e.g. AddToPlaylistModal
 */
const TrackSummary = ({ track, className }) => (
  <Container className={className}>
    {track.thumbnail && (
      <img src={track.thumbnail} alt="" className="image-border-radius" />
    )}
    <div>
      <p className="track-title">
        {track.title}
        {track.variationTitle && ` | ${track.variationTitle}`}
      </p>
      {track.album?.name && <p className="track-album">{track.album.name}</p>}
    </div>
  </Container>
);

export default TrackSummary;
